'use client';

import { useEffect, useState } from 'react';

import { IIconType } from '@/src/types';
import { InputSearchDestinationInput } from '@/src/components/input-search-destinations/InputSearchDestinationInput';
import { useInputSearch } from '@/src/components/input-search-destinations/useInputSearch';
import { InputSearchDestinationCard } from '@/src/components/input-search-destinations/InputSearchDestinationCard';
import { IZoneWithDestinationsAndPromo } from '@/src/modules/destinations/destinations.modules';

type IInputSearchProps = {
  destinations?: Record<string, IZoneWithDestinationsAndPromo>;
  placeholder: string | null;
  icon: IIconType | null;
  popularDestinations?: Record<string, IZoneWithDestinationsAndPromo>;
};

export const InputSearchDestinations = ({
  placeholder,
  icon,
  destinations,
  popularDestinations,
}: IInputSearchProps) => {
  const {
    search,
    setSearch,
    destinationsMemoized,
    focus,
    handleFocus,
    handleBlur,
    handleRedirect,
  } = useInputSearch(destinations);

  const destinationsToShow =
    destinationsMemoized && destinationsMemoized.length > 0
      ? destinationsMemoized
      : Object.values(popularDestinations ?? {});
  return (
    <div className={'relative w-full max-w-lg rounded-lg'}>
      <InputSearchDestinationInput
        search={search}
        setSearch={setSearch}
        placeholder={placeholder}
        icon={icon}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      {destinationsToShow.length > 0 && (
        <InputSearchDestinationCard
          destinations={destinationsToShow}
          onRedirect={handleRedirect}
          hide={!focus}
        />
      )}
    </div>
  );
};
